import { BaseEntity } from '../../../app/core';

export class Policy extends BaseEntity {
    idPv: number;
    number: number;
    endorsement: number;
    endorsementType: string;
    since: Date;
    sinceString: string;
    until: Date;
    untilString: string;
    dueDate: Date;
    dueDateString: string;
    amount: number;
    pathPolicy: string;
    pathCard: string;
    pathCertificate: string;
    hasPaymentConstancy: boolean;

    //Total Adeudado, solo para EXPORT.
    actualDebt: number;

    constructor(since: Date, until: Date, dueDate: Date) {
        super();

        this.sinceString = '';
        this.untilString = '';
        this.dueDateString = '';

        if (since) {
            this.sinceString = this.dateToString(since);
        }

        if (until) {
            this.untilString = this.dateToString(until);
        }

        if (dueDate) {
            this.dueDateString = this.dateToString(dueDate);
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/policy.ts